module.exports = __webpack_public_path__ + "img/benefits-16.39ead10e.svg";